// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ebf284a197734693d01f877cb7ec35b9bc4aba0d/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};